import { useState, useEffect } from 'react';
// Vendors
import { Navigate, Outlet, useLocation } from 'react-router-dom';

// Components
import Loader from '@/components/atoms/Loader/Loader';

// Store
import { oktaAuth } from '@/components/pages/LoginPage/index';
import TagManager from 'react-gtm-module';

const ProtectedRoute = () => {
  // Add explicit type annotation for the selector
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const checkAuth = async () => {
    const token = await oktaAuth.tokenManager.get('idToken').catch(() => false);
    setIsAuthenticated(!!token);
  };
  useEffect(()=>{
    const tagManagerArgs = {
      gtmId: 'GTM-N8GD3FRP',
    }
    TagManager.initialize(tagManagerArgs)
  })
  useEffect(() => {
    window.dataLayer.push({
      event: 'pageview',
      pagePath: location.pathname + location.search
    })
  
  }, [location]);

  useEffect(() => {
    checkAuth().catch((err: unknown) => console.log(err));
  }, []);

  if (isAuthenticated === null) return <Loader fullScreen />;

  //return <Outlet />;
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
